import { Component, inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GungModalService } from '../../../services/gung-modal/gung-modal.service';

@Component({
    selector: 'lib-activity-internal-wrapper',
    templateUrl: './activity-internal-wrapper.component.html',
    styleUrls: ['./activity-internal-wrapper.component.css'],
    standalone: false
})
export class ActivityInternalWrapperComponent {
  showList: boolean = true;

  protected modalService = inject(NgbModal);
  protected gungModalService = inject(GungModalService);

  openCreateModal() {
    this.gungModalService.openCreateActivityModal().then(
      result => {},
      reason => {
        console.log(`Dismissed ${reason}`);
      }
    );
  }
}
